
/**
 * 寻找多个字符串的公共前缀
 * @param {string[]} strs
 */
export function findBase(strs) {
	const baseOf = (a, b) => {
		if (b.indexOf(a) === 0) return a;
		if (a.indexOf(b) === 0) return b;
		let la = a.length, lb = b.length;
		for (var i = 0; i < la && i < lb; i++) {
			if (a[i] !== b[i]) {
				break;
			}
		}
		return a.substr(0, Math.max(0, i));
	};
	return strs.reduce((base, url) => baseOf(base, url));
}



// WEBPACK FOOTER //
// ./lib/helpers/findBase.js